/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// ALWAYS ROUTING TO 'acl.notfound' BUG FIX: https://github.com/zeit/serve/issues/515

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            meta : {
              rule: 'isLoggedIn',
            },
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('./views/Home.vue'),
                meta : {
                  rule: 'isLoggedIn',
                  // breadcrumb: 'foo',
                  pageTitle: "Home",
                },
              },
              {
                path: '/page2',
                name: 'page-2',
                component: () => import('./views/Page2.vue'),
                meta : {
                  rule: 'isLoggedIn',
                  // breadcrumb: 'foo',
                  pageTitle: "page 2",
                },
              },
              {
                path: '/content/products/list',
                name: 'Products',
                component: () => import('./views/content/products/ProductList.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Products', active: true },
                  ],
                  pageTitle: "Products",
                },
              },
              {
                path: '/push-notifications/send',
                name: 'Push Notifications',
                component: () => import('./views/push-notifications/PushNotificationCenter'),
                meta : {
                  rule: 'isAdmin',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Push Notifications', active: true },
                  ],
                  pageTitle: "Push Notifications",
                },
              },
              {
                path: '/content/products/detail',
                name: 'Product Detail',
                component: () => import('./views/content/products/ProductDetail.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Products', url: '/content/products/list'},
                    { title: 'Product Detail', active: true },
                  ],
                  pageTitle: "Product Detail",
                },
              },
              {
                path: '/content/companies/list',
                name: 'Companies',
                component: () => import('./views/content/companies/CompanyList.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Companies', active: true },
                  ],
                  pageTitle: "Companies",
                },
              },
              {
                path: '/content/trusted-partners',
                name: 'Trusted Partners',
                component: () => import('./views/content/trusted-partners/TrustedPartnersList.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Trusted Partners', active: true },
                  ],
                  pageTitle: "Trusted Partners",
                },
              },
              {
                path: '/content/trusted-partners/:id',
                name: 'Trusted Partners Detail',
                component: () => import('./views/content/trusted-partners/TrustedPartner.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Trusted Partners', active: true },
                  ],
                  pageTitle: "Trusted Partners",
                },
              },
              {
                path: '/content/protocol-categories',
                name: 'Protocol Categories',
                component: () => import('./views/content/protocol-categories/ProtocolCategoriesList.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Protocol Categories', active: true },
                  ],
                  pageTitle: "Protocol Categories",
                },
              },
              {
                path: '/content/protocol-categories/:id',
                name: 'Protocol Category Detail',
                component: () => import('./views/content/protocol-categories/ProtocolCategory.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Protocol Categories', active: true },
                  ],
                  pageTitle: "Protocol Categories",
                },
              },
              {
                path: '/content/protocols',
                name: 'Protocols',
                component: () => import('./views/content/protocols/ProtocolsList.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Protocols', active: true },
                  ],
                  pageTitle: "Protocols",
                },
              },
              {
                path: '/content/protocols/:id',
                name: 'Protocol Detail',
                component: () => import('./views/content/protocols/Protocol.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Protocols', active: true },
                  ],
                  pageTitle: "Protocols",
                },
              },
              {
                path: '/content/companies/detail',
                name: 'Company Detail',
                component: () => import('./views/content/companies/CompanyDetail.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Companies', url: '/content/companies/list'},
                    { title: 'Company Detail', active: true },
                  ],
                  pageTitle: "Company Detail",
                },
              },
              {
                path: '/content/books/list',
                name: 'Books/Titles',
                component: () => import('./views/content/books/BookList.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Books/Titles', active: true },
                  ],
                  pageTitle: "Books/Titles",
                },
              },
              {
                path: '/content/books/detail',
                name: 'Book Detail',
                component: () => import('./views/content/books/BookDetail.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Books/Titles', url: '/content/books/list'},
                    { title: 'Book Detail', active: true },
                  ],
                  pageTitle: "Book Detail",
                },
              },
              {
                path: '/content/books/analyses/detail',
                name: 'Scan Analysis Detail',
                component: () => import('./views/content/books/analyses/AnalysisDetail.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Books/Titles', url: '/content/books/list'},
                    { title: 'Book Detail' },
                    { title: 'Scan Analysis Detail', active: true },
                  ],
                  pageTitle: "Scan Analysis Detail",
                },
              },
              {
                path: '/content/books/analyses/categories/detail',
                name: 'Analysis Category Detail',
                component: () => import('./views/content/books/analyses/categories/CategoryDetail.vue'),
                meta : {
                  rule: 'isProductManager',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Content'},
                    { title: 'Books/Titles', url: '/content/books/list'},
                    { title: 'Book Detail' },
                    { title: 'Scan Analysis Detail' },
                    { title: 'Analysis Category Detail', active: true },
                  ],
                  pageTitle: "Analysis Category Detail",
                },
              },
              // users
              {
                path: '/users/list',
                name: 'Users',
                component: () => import('./views/users/UserList.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Users', active: true },
                  ],
                  pageTitle: "Users",
                },
              },
              {
                path: '/users/detail',
                name: 'User Detail',
                component: () => import('./views/users/UserDetail.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Users', url: '/users/list'},
                    { title: 'User Detail', active: true },
                  ],
                  pageTitle: "User Detail",
                },
              },
              {
                path: '/users/edit',
                name: 'User Edit',
                component: () => import('./views/users/UserEdit.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Users', url: '/users/list'},
                    { title: 'User Edit', active: true },
                  ],
                  pageTitle: "User Edit",
                },
              },
              // clients
              {
                path: '/clients/list',
                name: 'Clients',
                component: () => import('./views/clients/ClientList.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Clients', active: true },
                  ],
                  pageTitle: "Clients",
                },
              },
              {
                path: '/clients/detail',
                name: 'Client Detail',
                component: () => import('./views/clients/ClientDetail.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Clients', url: '/clients/list'},
                    { title: 'Client Detail', active: true },
                  ],
                  pageTitle: "Client Detail",
                },
              },
              {
                path: '/clients/edit',
                name: 'Client Edit',
                component: () => import('./views/clients/ClientEdit.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Clients', url: '/clients/list'},
                    { title: 'Client Edit', active: true },
                  ],
                  pageTitle: "Client Edit",
                },
              },
              // referral checks
              {
                path: '/referral-checks/list',
                name: 'Referral Checks',
                component: () => import('./views/referral-checks/ReferralCheckList.vue'),
                meta : {
                  rule: 'isAdmin',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Referral Checks', active: true },
                  ],
                  pageTitle: "Referral Checks",
                }
              },
              {
                path: '/dna/kits',
                name: 'DNA Kits',
                component: () => import('./views/dna/DnaKits.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Dna Kits', active: true },
                  ],
                  pageTitle: "Dna Kits",
                },
              },
              {
                path: '/dna/purchased-kits',
                name: 'Purchased Kits',
                component: () => import('./views/dna/PurchasedKits.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Purchased Kits', active: true },
                  ],
                  pageTitle: "Purchased Kits",
                },
              },
              {
                path: '/dna/replace-kit',
                name: 'Replace Kit',
                component: () => import('./views/dna/ReplaceKit.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Replace Kit', active: true },
                  ],
                  pageTitle: "Replace Kit",
                },
              },
              {
                path: '/orders',
                name: 'Orders',
                component: () => import('./views/orders/Orders.vue'),
                meta : {
                  rule: 'isCsr', //Todo: double check this rule
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Orders', active: true },
                  ],
                  pageTitle: "Orders",
                },
              },
              {
                path: '/orders/partner-invoices',
                name: 'Partner Invoices',
                component: () => import('./views/partner-invoices/PartnerOrderInvcs.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Partner Invoices', active: true }
                  ],
                  pageTitle: "Partner Invoices",
                },
              },
              {
                path: '/orders/:id',
                name: 'Order Detail',
                component: () => import('./views/orders/OrderDetail.vue'),
                meta : {
                  rule: 'isCsr',
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Orders', url: '/orders' },
                    { title: 'Order Detail', active: true}
                  ],
                  pageTitle: "Order Detail",
                },
              }
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            meta : {
              rule: 'isPublic',
            },
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/pages/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue'),
                meta : {
                  rule: 'isPublic',
                },
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue'),
                meta : {
                  rule: 'isPublic',
                },
              },
              {
                path: '/pages/not-authorized',
                name: 'page-not-authorized',
                component: () => import('@/views/pages/NotAuthorized.vue'),
                meta : {
                  rule: 'isPublic',
                },
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

// router.beforeEach((to, from, next) => {
//
//   // if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
//   //   router.push({ path: '/pages/login', query: { to: to.path } })
//   // }
//
//   return next();
// });

export default router
